import { render } from "./PollutionPredictionMod.vue?vue&type=template&id=636aa3b4&scoped=true"
import script from "./PollutionPredictionMod.vue?vue&type=script&lang=js"
export * from "./PollutionPredictionMod.vue?vue&type=script&lang=js"

import "./PollutionPredictionMod.vue?vue&type=style&index=0&id=636aa3b4&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636aa3b4"]])

export default __exports__